 
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Edit from 'images/icons/Edit.svg?react';
import { ModalType } from 'core/useCases/modal/types';
import { useApplicationById } from 'core/api/applications';
import { useModalStore } from 'stores/modal';

type UpdateApplicationButtonProps = {
    applicationId: string;
};

const UpdateApplicationButton: FC<UpdateApplicationButtonProps> = ({ applicationId }) => {
    const { t } = useTranslation();
    const openModal = useModalStore((state) => state.openModal);
    const application = useApplicationById(applicationId).data;

    const openApplicationModal = () => {
        openModal({
            defaultValues: application,
            title: t('application.update.label'),
            type: ModalType.Application,
        });
    };

    return (
        <button onClick={() => openApplicationModal()} type="button">
            <Edit />
        </button>
    );
};

export default UpdateApplicationButton;
